import {ILocale} from 'data/country';
import {atom} from 'recoil';

const localeIdentifier =
  navigator.language === 'en'
    ? 'en-US'
    : navigator.language === 'ko'
    ? 'ko-KR'
    : navigator.language === 'zh'
    ? 'zh-CN'
    : navigator.language === 'zh-CN'
    ? 'zh-CN'
    : navigator.language === 'uz'
    ? 'uz-UZ'
    : navigator.language === 'vi-VN'
    ? 'vi-VN'
    : navigator.language === 'ru-RU'
    ? 'ru-RU'
    : navigator.language === 'th-TH'
    ? 'th-TH'
    : 'ko-KR';

/**
 * OS 로케일 확인
 * @returns 로케일 값
 * @public
 */
const isOSLocale = (): ILocale => {
  const localeArray = [
    'en-US',
    'ko-KR',
    'zh-CN',
    'uz-UZ',
    'vi-VN',
    'ru-RU',
    'th-TH',
  ];
  let result: ILocale = 'ko-KR';
  for (let i = 0; i < localeArray.length; i++) {
    if (localeIdentifier === localeArray[i]) {
      result = localeIdentifier;
    }
  }
  return result;
};

/**
 * 로케일 상태 atom
 * @public
 */
export const localeState = atom<ILocale>({
  key: 'localeState',
  default: isOSLocale(),
});

/**
 * 로그인 상태 atom
 * @public
 */
export const isLoggedInState = atom({
  key: 'isLoggedIn',
  default: false,
});

/**
 * 사용자 정보 인터페이스
 * @public
 */
export interface IUserInfo {
  accessToken?: string;
  refreshToken?: string;
  user?: any;
  permission?: {
    Contractor?: any;
    PartnerCompany?: any;
    Team?: any;
    TongPlace?: any;
  };
}

/**
 * localStorage effect 함수
 * @param key - 저장할 키
 * @returns effect 함수
 * @public
 */
const localStorageEffect =
  (key: string) =>
  ({setSelf, onSet}: any) => {
    const savedValue = localStorage.getItem(key) ?? sessionStorage.getItem(key);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue));
    }
    onSet((newValue: any, _: any, isReset: any) => {
      if (newValue?.info?.autoLogin) {
        isReset
          ? localStorage.removeItem(key)
          : localStorage.setItem(key, JSON.stringify(newValue));
      } else {
        isReset
          ? sessionStorage.removeItem(key)
          : sessionStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };

/**
 * 사용자 정보 상태 atom
 * @public
 */
export const userInfoState = atom<IUserInfo | null>({
  key: 'userInfo',
  default: null,
  effects: [localStorageEffect('userInfo')],
});

/**
 * 테스트 모드 상태 atom
 * @public
 */
export const testModeState = atom({
  key: 'testMode',
  default: false,
});

/**
 * Base URL 타입
 * @public
 */
export type IBaseUrlType = 'dev' | 'prod';

/**
 * Base URL 타입 상태 atom
 * @public
 */
export const baseUrlTypeState = atom<IBaseUrlType>({
  key: 'baseUrlType',
  default: 'dev',
  effects: [localStorageEffect('baseUrlType')],
});
